export default __webpack_public_path__ + "static/media/sh-logo.9d21f8dd.svg";